import { useQuery } from "@tanstack/react-query"
import { klaviyoIntegrationQuery } from "../../lib/klaviyo/klaviyoIntegrationQuery"

export function useKlaviyoIntegrationQuery(...args: Parameters<typeof klaviyoIntegrationQuery>) {
  return useQuery(klaviyoIntegrationQuery(...args))
}
